/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_SuccessInputs */

const en_newsletter_success = /** @type {(inputs: Newsletter_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done. Expect email from Substack.`)
};

/**
* | output |
* | --- |
* | "Done. Expect email from Substack." |
*
* @param {Newsletter_SuccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_success = /** @type {((inputs?: Newsletter_SuccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_SuccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_success(inputs)
});